<mat-card [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
  <mat-card-content>
    <div class="flex flex-col gap-4">
      <div class="flex flex-row gap-6" style="font-size:20px">
        <span>Application History</span>
        <span>ORELAP Id: {{orelapId}}</span>
        <span>{{labName}}</span>
      </div>

      <div class="flex flex-row">
        <button type="button" class="m-8" mat-raised-button color="primary" 
          (click)="createNewApplication()">Create or Renew App</button>
        <button (click)="viewApplication('view')" routerLink="/application-menu" class="m-8" mat-raised-button
          [disabled]="selectedApplication.labId === 0" color="primary">View</button>
        <button (click)="viewApplication('edit')" routerLink="/application-menu" type="button" class="m-8"
          mat-raised-button [disabled]="selectedApplication.lockedByAdmin === 'Y' || selectedApplication.labId === 0"
          color="accent">Edit</button>
        <button *ngIf="isPrimary" [disabled]="selectedApplication.labId === 0"
          routerLink="/ptMenu" type="button" class="m-8" mat-raised-button 
          color="accent">PT</button>

        <button type="button" class="m-8" mat-raised-button [disabled]="selectedApplication.labId === 0" color="alt"
          (click)="applicationReport()">Print</button>
        <button type="button" class="m-8" mat-raised-button [disabled]="selectedApplication.labId === 0" color="alt"
          (click)="foaReport()">FOAs</button>
        <button type="button" class="m-8" mat-raised-button [disabled]="selectedApplication.labId === 0" color="alt"
          (click)="techReport()">Tech</button>
        <button (click)="deleteApplication()" type="button" class="m-8" mat-raised-button
          [disabled]="selectedApplication.lockedByAdmin === 'Y'|| selectedApplication.labId === 0"
          color="warn">Delete</button>
      </div>

      <div class="flex flex-col" *ngIf="displayNewApplicationMessage">
        <span style="font-size: larger" *ngIf="!newApplicationResult.applicationCreated">
          The application could not be created. Please contact the ORELAP Administrator.
        </span>
        <span style="font-size: larger"
          *ngIf="newApplicationResult.applicationCreated && !newApplicationResult.newMethodFound">
          The new application has been added. Please update and verify the information including both methods and
          analytes then process the application.
        </span>
        <span style="font-size: larger"
          *ngIf="newApplicationResult.applicationCreated && newApplicationResult.newMethodFound">
          The new application has been added. Please update and verify the information including both methods and
          analytes then process the application.
          Note: Some of the old method codes have been replaced with new TNI method codes. If you have any questions
          please contact the ORELAP Administrator.
        </span>
      </div>

      <div class="flex flex-col">
        <div class="flex flex-row">
          <mat-form-field class="w-3/10 sm:w-full">
            <input matInput (keyup)="filterTable($event.target.value)" placeholder="Filter" />
          </mat-form-field>
        </div>

        <div style="overflow-x:auto">
          <mat-table [dataSource]="dataSource" matSort #ApplicationSort="matSort" class="mat-elevation-z8 w-full">
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <mat-radio-group [(ngModel)]="selectedApplication">
                  <mat-radio-button [value]="application" color="primary"></mat-radio-button>
                </mat-radio-group>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="application">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Application</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">Application</span>
                <span>{{application.application}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="onSiteAssessment">
              <mat-header-cell *matHeaderCellDef mat-sort-header>On Site Assessment</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">On Site</span>
                {{application.onSiteAssessment}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="approvedByAdmin">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Approved By Admin</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">Approved</span>
                {{application.approvedByAdmin}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="lockedByAdmin">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Locked By Admin</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">Locked</span>
                {{application.lockedByAdmin}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="createDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">Created</span>
                {{application.createDate}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
              <mat-cell *matCellDef="let application" (click)="selectApplication(application)">
                <span class="mobile-label">Status</span>
                {{application.status}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef>Inspection</mat-header-cell>
              <mat-cell *matCellDef="let application">
                <span class="mobile-label">Inspection</span>
                <div *ngIf="application.assessorsAllocated !== null">
                  <button (click)="selectInspection(application)" *ngIf="application.assessorsAllocated === 'COMPLETED'"
                    type="button" class="m-8" mat-raised-button color="primary">
                    View
                  </button>
                  <button (click)="selectInspection(application)"
                    *ngIf="(application.onSiteAssessment === 'Y' || application.onSiteAssessment === 'P') && application.assessorsAllocated !== 'COMPLETED'"
                    type="button" class="m-8" mat-raised-button color="accent">
                    Edit
                  </button>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>
        </div>

        <mat-paginator [pageSizeOptions]="[5, 10, 20]" #ApplicationPaginator="matPaginator"
          showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>

